// extracted by mini-css-extract-plugin
export default {"productGallery":"sK-z","inQuickShop":"tK-z"};